/* eslint-disable no-unused-vars */
import "./IncompleteSettingsModal.css";
import React, { Fragment, useState } from "react";
import { Modal } from "@mui/material";
import { Link } from "react-router-dom";

const IncompleteSettingsModal = ({ AuthUser, ClientData, ListedImage }) => {
  // Modal Start
  const [OpenIncompleteSettingsModal, setOpenIncompleteSettingsModal] =
    useState(true);

  const handleOpenIncompleteSettingsModal = () => {
    setOpenIncompleteSettingsModal(true);
  };

  const handleCloseIncompleteSettingsModal = () => {
    setOpenIncompleteSettingsModal(false);
  };
  // Modal End

  return (
    <Fragment>
      <Fragment>
        {/* <Link to="#" onClick={handleOpenIncompleteSettingsModal}>
          Settings
        </Link> */}
        {window.location.pathname !== "/user/profile" &&
          (AuthUser || ClientData?.businessName === "") && (
            <Modal
              open={OpenIncompleteSettingsModal}
              onClose={handleCloseIncompleteSettingsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="ModalStyle"
              hideBackdrop={true}
              style={{
                backdropFilter: "blur(1x)",
                backgroundColor: "rgba(204, 204, 204, 0.4)",
              }}
            >
              <div
                className="modal-dialog modal-lg"
                style={{ position: "relative", top: "14%" }}
              >
                <div className="modal-content incomplete-settings-modal-content">
                  {/* <p onClick={handleCloseIncompleteSettingsModal}>
                    <svg
                      className="cross-svg d-none"
                      style={{
                        position: "absolute",
                        top: "-1px",
                        right: "-6px",
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                        zIndex: 1,
                      }}
                      width="44"
                      height="44"
                      viewBox="0 0 44 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_216_88)">
                        <path
                          d="M22 0C12.046 0 4 8.046 4 18C4 27.954 12.046 36 22 36C31.954 36 40 27.954 40 18C40 8.046 31.954 0 22 0ZM31 24.462L28.462 27L22 20.538L15.538 27L13 24.462L19.462 18L13 11.538L15.538 9L22 15.462L28.462 9L31 11.538L24.538 18L31 24.462Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_216_88"
                          x="0"
                          y="0"
                          width="44"
                          height="44"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_216_88"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_216_88"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </p> */}

                  <div className="row incomplete-settings-modal-row">
                    <div className="incomplete-settings-modal-left-content col-xl-6 col-xxl-6 col-lg-6 col-md-12 col-sm-12">
                      <div className="settings-modal-top-heading col-xl-6 col-xxl-6 col-lg-6 col-md-12 col-sm-12">
                        <h3 className="welcome-heading">
                          Welcome To Land Book
                        </h3>
                        <p className="description-summary">
                          Start your Landbook journey today and complete your
                          account.
                        </p>
                      </div>
                      <ul className="settings-modal-content-container">
                        <div className="settings-modal-content">
                          <li>
                            <div className="fixes-container">
                              <div className="description-container">
                                <p className="title-of-task">
                                  Why give your phone number?
                                </p>
                                <p className="description-of-task">
                                  Upon giving your phone number, people will
                                  contact with you via your phone number when
                                  you share your property details.
                                </p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="fixes-container">
                              <div className="description-container">
                                <p className="title-of-task">
                                  Why give your business name and business logo?
                                </p>
                                <p className="description-of-task">
                                  Upon giving your business name and logo you
                                  will have an identity in market.
                                </p>
                              </div>
                            </div>
                          </li>
                          <div className="fixes-container">
                            <div className="description-container">
                              <p className="title-of-task">
                                Why verify your email?
                              </p>
                              <p className="description-of-task">
                                Upon verifying your email, you will receive
                                regular notifications from Landbook on your
                                verified email.
                              </p>
                            </div>
                          </div>
                          {/* 
                      <div className="fixes-container">
                        <div className="svg-image">
                          <svg
                            width="37"
                            height="37"
                            viewBox="0 0 37 37"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_643_2159)">
                              <path
                                d="M20.0641 24.0503L15.4675 28.6468L15.0685 29.0459C14.753 29.3613 14.5758 29.7892 14.5758 30.2352V30.3286V32.0104V35.318C14.5758 36.2468 15.3288 36.9999 16.2577 36.9999H21.3405C21.7866 36.9999 22.2144 36.8227 22.5298 36.5072L36.5074 22.5295C37.1643 21.8727 37.1643 20.8079 36.5074 20.1511L31.4246 15.0683C31.1093 14.753 30.6815 14.5757 30.2355 14.5757C29.7894 14.5757 29.3616 14.7528 29.0462 15.0683L22.4474 21.6671L21.2555 22.8591L20.0641 24.0503Z"
                                fill="#5286FA"
                              />
                              <path
                                d="M5.85836 7.03564C5.85836 10.9151 9.01449 14.0713 12.894 14.0713C16.7735 14.0713 19.9297 10.9151 19.9297 7.03564C19.9297 3.15613 16.7735 0 12.894 0C9.01449 0 5.85836 3.15613 5.85836 7.03564Z"
                                fill="#EFC27B"
                              />
                              <path
                                d="M1.68184 32.0107H14.5758V30.3289V30.2355C14.5758 29.7895 14.7529 29.3618 15.0684 29.0463L15.4674 28.6471L20.064 24.0506L21.2553 22.8592L22.4473 21.6673C20.022 18.9876 16.5763 17.4351 12.8939 17.4351C5.78428 17.435 0 23.2192 0 30.3289C0 31.2577 0.753008 32.0107 1.68184 32.0107Z"
                                fill="#A4E276"
                              />
                              <path
                                d="M5.85836 7.03564C5.85836 10.9151 9.01449 14.0713 12.894 14.0713V0C9.01449 0 5.85836 3.1562 5.85836 7.03564Z"
                                fill="#ECB45C"
                              />
                              <path
                                d="M12.894 17.4351C5.78429 17.4351 0 23.2193 0 30.329C0 31.2578 0.753008 32.0108 1.68184 32.0108H12.894V17.4351Z"
                                fill="#64C37D"
                              />
                              <path
                                d="M31.4246 15.0683C31.1092 14.753 30.6815 14.5757 30.2354 14.5757C29.7894 14.5757 29.3615 14.7528 29.0462 15.0683L22.4474 21.6671L21.2554 22.8591L20.0641 24.0504L15.4674 28.6469L15.0684 29.046C14.7529 29.3614 14.5758 29.7893 14.5758 30.2353V30.3286V32.0105V35.3181C14.5758 35.8028 14.7819 36.2384 15.1102 36.5452L34.0058 17.6496L31.4246 15.0683Z"
                                fill="#424EDE"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_643_2159">
                                <rect width="37" height="37" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div className="description-container">
                          {ClientData?.businessName === "" && (
                            <p className="title-of-task">
                              Enter Your Business Name
                            </p>
                          )}
                          <p className="description-of-task">
                            Complete identity verification to have good time in
                            Land Book
                          </p>
                        </div>
                      </div>

                    {!ListedImage && (
                      <div className="fixes-container">
                        <div className="svg-image">
                          <svg
                            width="37"
                            height="37"
                            viewBox="0 0 37 37"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_643_2159)">
                              <path
                                d="M20.0641 24.0503L15.4675 28.6468L15.0685 29.0459C14.753 29.3613 14.5758 29.7892 14.5758 30.2352V30.3286V32.0104V35.318C14.5758 36.2468 15.3288 36.9999 16.2577 36.9999H21.3405C21.7866 36.9999 22.2144 36.8227 22.5298 36.5072L36.5074 22.5295C37.1643 21.8727 37.1643 20.8079 36.5074 20.1511L31.4246 15.0683C31.1093 14.753 30.6815 14.5757 30.2355 14.5757C29.7894 14.5757 29.3616 14.7528 29.0462 15.0683L22.4474 21.6671L21.2555 22.8591L20.0641 24.0503Z"
                                fill="#5286FA"
                              />
                              <path
                                d="M5.85836 7.03564C5.85836 10.9151 9.01449 14.0713 12.894 14.0713C16.7735 14.0713 19.9297 10.9151 19.9297 7.03564C19.9297 3.15613 16.7735 0 12.894 0C9.01449 0 5.85836 3.15613 5.85836 7.03564Z"
                                fill="#EFC27B"
                              />
                              <path
                                d="M1.68184 32.0107H14.5758V30.3289V30.2355C14.5758 29.7895 14.7529 29.3618 15.0684 29.0463L15.4674 28.6471L20.064 24.0506L21.2553 22.8592L22.4473 21.6673C20.022 18.9876 16.5763 17.4351 12.8939 17.4351C5.78428 17.435 0 23.2192 0 30.3289C0 31.2577 0.753008 32.0107 1.68184 32.0107Z"
                                fill="#A4E276"
                              />
                              <path
                                d="M5.85836 7.03564C5.85836 10.9151 9.01449 14.0713 12.894 14.0713V0C9.01449 0 5.85836 3.1562 5.85836 7.03564Z"
                                fill="#ECB45C"
                              />
                              <path
                                d="M12.894 17.4351C5.78429 17.4351 0 23.2193 0 30.329C0 31.2578 0.753008 32.0108 1.68184 32.0108H12.894V17.4351Z"
                                fill="#64C37D"
                              />
                              <path
                                d="M31.4246 15.0683C31.1092 14.753 30.6815 14.5757 30.2354 14.5757C29.7894 14.5757 29.3615 14.7528 29.0462 15.0683L22.4474 21.6671L21.2554 22.8591L20.0641 24.0504L15.4674 28.6469L15.0684 29.046C14.7529 29.3614 14.5758 29.7893 14.5758 30.2353V30.3286V32.0105V35.3181C14.5758 35.8028 14.7819 36.2384 15.1102 36.5452L34.0058 17.6496L31.4246 15.0683Z"
                                fill="#424EDE"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_643_2159">
                                <rect width="37" height="37" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <div className="description-container">
                          {!ListedImage && (
                            <p className="title-of-task">
                              Upload Your Business Logo
                            </p>
                          )}
                          <p className="description-of-task">
                            Complete identity verification to have good time in
                            Land Book
                          </p>
                        </div>
                      </div>
                    )} */}
                        </div>
                      </ul>
                      <Link to="/user/profile" className="modal-btn-container">
                        <button>Go To Profile</button>
                      </Link>
                    </div>
                    <div className="incomplete-settings-modal-right-image col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6"></div>
                  </div>
                </div>
              </div>
            </Modal>
          )}
      </Fragment>
    </Fragment>
  );
};

export default IncompleteSettingsModal;
